import * as actions from "./actions";
import update from "immutability-helper";

let initialState = {
  savelendSpecialAccountOrders: [],
};

const savelendMoneyReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.GET_SAVELEND_SPECIAL_ACCOUNT_ORDERS_SUCCESS:
      return update(state, {
        savelendSpecialAccountOrders: { $set: action.response },
      });
    default:
      return state;
  }
};

export default savelendMoneyReducer;
